import request from '../../constants/fetch';

/**
 * API Get faculties
 * @returns {Promise<unknown>}
 */
export const getUniversitiesService = (options = {}) =>
    request.get(`/university/all`, options);

/**
 * API Get faculties
 * @returns {Promise<unknown>}
 */
export const getFacultiesService = (options = {}) =>
    request.get(`/faculty/all`, options);

/**
 * API Get faculties
 * @returns {Promise<unknown>}
 */
export const getSpecialitiesService = (options = {}) =>
    request.get(`/speciality/all`, options);

/**
 * API Edit university
 * @returns {Promise<unknown>}
 */
export const editUniversityStructureService = (data, options = {}) =>
    request.put(`/university`, data, options);

/**
 * API Add university
 * @returns {Promise<unknown>}
 */
export const addUniversityStructureService = (data) =>
    request.post(`/university`, data);

/**
 * API Add university
 * @returns {Promise<unknown>}
 */
export const deleteUniversityStructureService = (id) =>
    request.delete(`/university/${id}`, {});

/**
 * API Approved university
 * @returns {Promise<unknown>}
 */
export const approvedUniversityStructureService = (id, approved) =>
    request.put(`/university/approve/${id}?status=${approved}`, {});

/**
 * API Edit faculty
 * @returns {Promise<unknown>}
 */
export const editFacultyStructureService = (data, options = {}) =>
    request.put(`/faculty`, data, options);

/**
* API Add faculty
* @returns {Promise<unknown>}
*/
export const addFacultyStructureService = (data) =>
    request.post(`/faculty`, data);

/**
* API Add faculty
* @returns {Promise<unknown>}
*/
export const deleteFacultyStructureService = (id) =>
    request.delete(`/faculty/${id}`, {});

/**
* API Approved faculty
* @returns {Promise<unknown>}
*/
export const approvedFacultyStructureService = (id, approved) =>
    request.put(`/faculty/approve/${id}?status=${approved}`, {});

/**
 * API Edit speciality
 * @returns {Promise<unknown>}
 */
export const editSpecialityStructureService = (data, options = {}) =>
    request.put(`/speciality`, data, options);

/**
* API Add speciality
* @returns {Promise<unknown>}
*/
export const addSpecialityStructureService = (data) =>
    request.post(`/speciality`, data);

/**
* API Add speciality
* @returns {Promise<unknown>}
*/
export const deleteSpecialityStructureService = (id) =>
    request.delete(`/speciality/${id}`, {});

/**
* API Approved speciality
* @returns {Promise<unknown>}
*/
export const approvedSpecialityStructureService = (id, approved) =>
    request.put(`/speciality/approve/${id}?status=${approved}`, {});
